import React from 'react';
import { Link } from 'react-router-dom';
import StaticPage, { SUPPORT_EMAIL } from './StaticPage';

/** TCH-16-FR-11 — Help. T0 scope is a reachable page with a real contact route. */
const Help: React.FC = () => (
  <StaticPage
    title="Centro de ayuda"
    intro="Respuestas rápidas y cómo contactarnos si algo no sale bien."
  >
    <h2 style={{ fontSize: 18, marginTop: 28 }}>Preguntas frecuentes</h2>
    <dl style={{ margin: 0 }}>
      <Item q="No me llegó el correo de verificación">
        Revisa tu carpeta de spam o correo no deseado. Desde la pantalla de verificación puedes
        pedir un código nuevo con “Reenviar código”.
      </Item>
      <Item q="Olvidé mi contraseña">
        Usa <Link to="/forgot-password">“Olvidé mi contraseña”</Link> en la pantalla de inicio de
        sesión. Te enviamos un código para elegir una nueva.
      </Item>
      <Item q="Soy profesor y no puedo publicar mi curso">
        Solo puedes publicar cuando tu solicitud de profesor está aprobada. En “Mis cursos” verás el
        estado de tu solicitud y qué falta.
      </Item>
      <Item q="Mi pago quedó pendiente">
        En tu panel, la inscripción muestra un botón para completar el pago. La inscripción no se
        duplica: retoma la que ya existe.
      </Item>
      <Item q="Una sesión no ocurrió o tuvo un problema">
        En el detalle de la inscripción puedes reportar un problema con esa sesión. El pago de esa
        sesión queda retenido mientras lo revisamos.
      </Item>
    </dl>

    <h2 style={{ fontSize: 18, marginTop: 32 }}>¿Necesitas más ayuda?</h2>
    <p style={{ color: '#444', fontSize: 15 }}>
      Escríbenos a <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>. Si tu duda es sobre una
      sesión o un pago, incluye el nombre del curso y la fecha — así lo resolvemos más rápido.
    </p>
  </StaticPage>
);

const Item: React.FC<{ q: string; children: React.ReactNode }> = ({ q, children }) => (
  <div style={{ padding: '14px 0', borderBottom: '1px solid #e9ecef' }}>
    <dt style={{ fontWeight: 700, marginBottom: 4 }}>{q}</dt>
    <dd style={{ margin: 0, color: '#444', fontSize: 14.5, lineHeight: 1.6 }}>{children}</dd>
  </div>
);

export default Help;
